import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { OrganizationsService } from '../../../../services/organizations/organizations.service.js';
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { UserMetric } from 'allai-admin-shared';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { OverlayModule } from '@angular/cdk/overlay';
import { OrganizationsFilterService } from '../../../../services/organizations/organizations-filter.service.js';
import { Router } from '@angular/router';
import { MatSort, MatSortModule } from '@angular/material/sort';

/** The organization metric page */
@Component({
	selector: 'app-organization-users',
	imports: [
		MatButtonModule,
		MatDatepickerModule,
		MatFormFieldModule,
		MatIconModule,
		FormsModule,
		MatInputModule,
		MatTableModule,
		ReactiveFormsModule,
		OverlayModule,
		MatSortModule
	],
	providers: [provideNativeDateAdapter()],
	templateUrl: './organization-users.component.html',
	styleUrl: './organization-users.component.scss'
})
export class OrganizationUsersComponent implements OnInit, OnDestroy {

	dateRangeControl: FormGroup;

	userDataSource: MatTableDataSource<UserMetric>;
	readonly displayedColumns: (keyof UserMetric)[] = ['id', 'first_name', 'last_name', 'user_type', 'enabled', 'transcripts'];

	@ViewChild(MatSort)
	sort:MatSort;

	@ViewChild(MatTable)
	table: MatTable<UserMetric>;


	constructor(private organizationsService: OrganizationsService,
		private organizationsFilterService: OrganizationsFilterService,
		private router: Router
	) {
	}

	ngOnInit() {


		this.dateRangeControl = new FormGroup({
	    start: new FormControl<Date | null>(this.organizationsFilterService.userMetricsStartDate),
  	  end: new FormControl<Date | null>(this.organizationsFilterService.userMetricsEndDate)
	  });
		this.dateRangeControl.valueChanges.subscribe((value) => this.organizationsFilterService.userMetricsRange = value);


		this.organizationsService.onNewOrganizationDetail.subscribe(() => {
			this.refresh();
		});

	}

	private refresh() {
		let organizationDetail = this.organizationsService.organizationDetail;
		let data = organizationDetail.users;
		this.userDataSource = new MatTableDataSource<UserMetric>(data);
		this.userDataSource.sort = this.sort;
		this.table?.renderRows();
	}

	ngOnDestroy() {
	}
	gotoRow(row: UserMetric) {
		let url = this.router.serializeUrl(this.router.createUrlTree(['/', "users", row.id]));
		window.open(url, `_user_${row.id}`);
	}

		/** Apply a filter from the search bar */
	applyFilter(event:Event) {
		const filterValue = (event.target as HTMLInputElement).value;
		this.userDataSource.filter = filterValue.trim().toLowerCase();
	}
}
